const s = {
  name: "Pointer",
  dimensions: { width: 30, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 30 40" style="enable-background:new 0 0 30 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M15,9c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S18.3,9,15,9z M11,15c0-2.2,1.8-4,4-4s4,1.8,4,4s-1.8,4-4,4
			S11,17.2,11,15z"/>
		<path class="st0" d="M15,0C6.7,0,0,6.7,0,15c0,6.8,3.7,13,7.2,17.4c1.8,2.2,3.6,4,4.9,5.2c0.7,0.6,1.2,1.1,1.6,1.4
			c0.2,0.2,0.4,0.3,0.5,0.4c0.1,0,0.1,0.1,0.1,0.1l0,0l0,0l0,0l0,0c0,0,0,0,0.6-0.8l-0.6,0.8L15,40l0.6-0.5L15,38.7
			c0.6,0.8,0.6,0.8,0.6,0.8l0,0l0,0l0,0l0,0c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.3-0.2,0.5-0.4c0.4-0.3,1-0.8,1.6-1.4
			c1.3-1.2,3.1-3,4.9-5.2C26.3,28,30,21.8,30,15C30,6.7,23.3,0,15,0z M16.5,36.1c-0.6,0.6-1.1,1-1.5,1.3c-0.4-0.3-0.9-0.8-1.5-1.3
			c-1.3-1.2-3-2.9-4.7-5C5.3,26.9,2,21.2,2,15C2,7.8,7.8,2,15,2s13,5.8,13,13c0,6.2-3.3,11.9-6.8,16.1
			C19.5,33.2,17.8,34.9,16.5,36.1z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Pointer
};
